class Highlighter {
    highlight (string) {
        const matches = string.match(/`+.*?`+/gs)

        if (matches) {
            matches.forEach((match) => {
                let highlighted

                if (match.startsWith('```')) {
                    highlighted = match.replace(/^```(.*?)```$/s, '<pre><code>$1</code></pre>')
                } else {
                    highlighted = match.replace(/^`([^`].*?[^`])`$/, '<code>$1</code>')
                }

                string = string.replace(match, highlighted)
            })
        }

        return string
    }
}

export default Highlighter
